export const stringFilters = {
    strLimit: function (value, size) {
        if (!value)
            return "";
        value = value.toString();
        if (value.length <= size) {
            return value;
        }
        return value.substr(0, size) + "...";
    },
    firstUpper: function (value) {
        if (!value)
            return "";
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
    },
    firstLower: function (value) {
        if (!value)
            return "";
        value = value.toString();
        return value.charAt(0).toLowerCase() + value.slice(1);
    },
    strLimitEnd: function (value, size) {
        if (!value)
            return "";
        value = value.toString();
        if (value.length <= size) {
            return value;
        }
        return "..." + value.substr(value.length - size, value.length);
    },
};
